import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import HomeIcon from "@mui/icons-material/Home";
import { IconButton, Box} from "@mui/material";

export default function History() {
  const { getHistoryOfUser } = useContext(AuthContext);
  const [meetings, setMeetings] = useState([]);
  // const [error, setError] = useState(null);

  const routeTo = useNavigate();

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const history = await getHistoryOfUser();
        setMeetings(history);
      } catch (err) {
       // implement snakebar
      }
    };

    fetchHistory();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <Box p={2}>
      {/* Home Icon */}
      <IconButton onClick={() => routeTo("/home")}>
        <HomeIcon />
      </IconButton>

      {/* Error Snackbar */}
      {/* {error && (
        <Snackbar
          open={true}
          autoHideDuration={6000}
          onClose={() => setError(null)}
        >
          <Alert severity="error" onClose={() => setError(null)}>
            {error}
          </Alert>
        </Snackbar>
      )} */}

      {/* Meeting Cards */}
      {(meetings.length >
       0 ? (
        meetings.map((e, index) => (
          <Card key={index} variant="outlined" >
            <CardContent>
              <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                Code: {e.meetingCode }
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                Date: { formatDate(e.date) }
              </Typography>
            </CardContent>
            {/* <Button>Learn more</Button> */}
          </Card>
        ))
      ) : 
        <></>
      )}
    </Box>
  );
}
